const routes = require('../../config/router.js');

export default function goTo(goTo, emp) {
    if (sessionStorage.getItem('totem')) {
        window.location.href = routes.routes.frontend + goTo + "?emp=" + emp + "&totem=" + JSON.parse(sessionStorage.getItem('totem')).nome;
    } else {
        window.location.href = routes.routes.frontend + goTo + "?emp=" + emp;
    }
}